/*
 * form basic validation
 */
(function () {
	'use strict'

	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	var forms = document.querySelectorAll('.needs-validation');

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms).forEach(function(form) {
		form.addEventListener('submit', function(event) {
			if (!form.checkValidity()) {
				event.preventDefault();
				event.stopPropagation();
				form.querySelectorAll('.is-valid, .is-invalid').forEach(function(item) {
					item.classList.remove('is-valid is-invalid');
				});
			}
			form.classList.add('was-validated');
		}, false)
	});


	// bouton génération mdp
	document.querySelectorAll('[data-create-password]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
			var passwordLength = 12;
			var password = "";
			for (var i = 0; i <= passwordLength; i++) {
				var randomNumber = Math.floor(Math.random() * chars.length);
				password += chars.substring(randomNumber, randomNumber + 1);
			}
			document.querySelectorAll(btn.dataset.createPassword).forEach(function(input) {
				input.value = password;
			});
		});
	});

	// select placeholder
	document.querySelectorAll('.form-select.has-placeholder').forEach(function(select) {
		if (select.value == '')
			select.classList.add('_empty');
		select.addEventListener('change', function(event) {
			if (select.value == '')
				select.classList.add('_empty');
			else
				select.classList.remove('_empty');
		});
	});

	// reset => on remet les placeholders sur les select
	document.querySelectorAll('form').forEach(function(form) {
		form.addEventListener('reset', function(event) {
			form.querySelectorAll('.form-select.has-placeholder').forEach(function(select) {
				select.classList.add('_empty');
			});
		});
	});

})();

